<div style="margin-top: 10px;">
  <form [formGroup]="unitForm">
    <mat-card>
      <mat-card-content>
        <div class="example-button-row">
          <span class="__filter_icon" style="background-color: white;">
          </span>
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Unit
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)"  >
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="header" width="450px">
                  <div class="sorting_header">
                    <span mat-sort-header>Unit Name</span>
                    <input placeholder="Search by Unit Name" matInput autocomplete="off" formControlName="name" class="mat-input-custom">
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">{{element.name}}</td>
              </ng-container>
                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef class="header" width="450px">
                            <div class="sorting_header">
                                <span mat-sort-header>Unit Code</span>
                                 <input placeholder="Search by Unit Code" matInput autocomplete="off" formControlName="code" class="mat-input-custom">
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.code}}</td>
                    </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="header" width="450px" >
                  <span mat-sort-header>Action</span></th>
                  <td mat-cell *matCellDef="let element">
                    <span class="__action_edit_icon" (click)="openForm(element)">
                      <mat-icon mat-cell>create</mat-icon>
                    </span>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="unitColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: unitColumns;"></tr>
              </table>
            </div>
          }
        </mat-card-content>
      </mat-card>
      @if (viewPermission) {
        <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [length]="totalUnitRecords"></mat-paginator>
      }
    </form>
  </div>

